import { IResponse } from "models";

export enum ActionType {
  INFORMATION_SETTING = "action/INFORMATION_SETTING",
  INFORMATION_SETTING_SUCCESS = "action/INFORMATION_SETTING_SUCCESS",
  INFORMATION_SETTING_ERROR = "action/INFORMATION_SETTING_ERROR",
  INFORMATION_SETTING_RESET = "action/INFORMATION_SETTING_RESET",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface IResult {
  identity_code_title: string;
  is_verify_identity_code: boolean;
  super_city_code: string;
  name: string;
  is_show_title: boolean;
  is_able_consultation_nav: boolean;
  is_household_based?: any;
  super_city_condition?: any;
}

export interface IInformationSettingResponse extends IResponse {
  result?: IResult;
}
